<template >
  <v-app>
    <div>
      <div v-if="errorList != ''" style="text-align: center;margin:10px;">
        <h3 style="font-size:14px;" class="txtClrRed">{{$t('ErrorList')}}: {{errorList}}</h3>
      </div>

      <!-- search summary -->
      <v-layout wrap>
        <!-- Stall List -->
        <v-flex v-if="globalVar.mode == 'normal' && realKtnId == 0 " xs11 md6 class="column">
          <v-select
            v-model="sltStall"
            style="width:100%;font-size:16px;"
            :items="stallNameList"
            :label="$t('stallList')"
            outlined
            no-data-text="Empty"
            @input="onSelectStall"
          ></v-select>
          <!-- <div
            v-if="invalidbcdid"
            class="txtClrRed"
            style="margin-top:-20px;"
          >{{ $t('PlsSltBrch') }}</div>-->
        </v-flex>

        <!-- Date Between -->
        <v-flex xs9 md5 class="column">
          <v-layout>
            <v-menu
              v-model="dpSE"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  slot="activator"
                  v-model="dpdateSE"
                  class="dateTxt"
                  style="cursor: pointer;"
                  :label="$t('DateBetween')"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-card>
                <v-layout style="background-color: #2093e4 !important;color: white !important;">
                  <p style="margin:8px;">{{$t('DateFrom')}}</p>
                </v-layout>
                <v-date-picker
                  v-model="dpdateStart"
                  :placeholder="$t('DateStart')"
                  :type="'date'"
                  style="max-width:450px;"
                  no-title
                  :locale="$t('langTxt')"
                  color="primary"
                ></v-date-picker>
                <v-layout style="background-color: #2093e4 !important;color: white !important;">
                  <p style="margin:8px;">{{$t('DateTo')}}</p>
                </v-layout>
                <v-date-picker
                  v-model="dpdateEnd"
                  :placeholder="$t('DateTo')"
                  :type="'date'"
                  style="max-width:450px;"
                  no-title
                  :locale="$t('langTxt')"
                  color="primary"
                >
                  <v-spacer></v-spacer>

                  <v-btn color="primary" @click="dpSE = false">{{ $t('Close') }}</v-btn>
                  <v-btn
                    style="margin-left:10px;"
                    color="primary"
                    @click="onChangeDateSE(dpdateStart,dpdateEnd)"
                  >{{ $t('Ok') }}</v-btn>
                </v-date-picker>
              </v-card>
            </v-menu>
          </v-layout>

          <div v-if="invalidStartEnd" class="txtClrRed">{{ $t('PlsPikVldDate') }}</div>
          <div v-if="invalidStartexceedEnd" class="txtClrRed">{{ $t('DFrmExcDTo') }}</div>
        </v-flex>

        <!-- Search Btn -->
        <v-flex xs3 md1>
          <button
            style="background-color:#1976d2;color:white;margin:8px;padding:10px;font-size:14px;border-radius:5px;"
            @click="searchSummary()"
          >{{ $t('Search') }}</button>
        </v-flex>
      </v-layout>

      <!-- summary -->
      <v-container style="padding-top:0px;">
        <h2 style="font-size:18px;">{{$t('Summary')}}</h2>
        <v-card style="background-color:#FFFFE0;">
          <v-card-text style="padding:10px;">
            <v-container grid-list-md style="padding-top:0px;padding-bottom:0px;">
              <h4
                class="inputTitle"
              >{{$t('UnpaidAmt')}} : RM {{summary.UnpaidAmt | currency(summary.UnpaidAmt)}}</h4>
              <hr />
              <h4
                class="inputTitle"
              >{{$t('CPaidAmount')}} : RM {{summary.PaidAmt | currency(summary.PaidAmt)}}</h4>
              <hr />
              <h4
                class="inputTitle"
              >{{$t('ProgressAmount')}} : RM {{summary.Progress | currency(summary.Progress)}}</h4>
              <hr />
              <h4
                class="inputTitle"
              >{{$t('CancelAmt')}} : RM {{summary.Cancel | currency(summary.Cancel)}}</h4>
              <hr />
              <h4
                class="inputTitle"
              >{{$t('RefundAmt')}} : RM {{summary.Refund | currency(summary.Refund)}}</h4>
            </v-container>
          </v-card-text>
        </v-card>
      </v-container>

      <!-- order list -->
      <v-layout wrap style="margin-top:10px;">
        <v-card
          v-for="orderHdr in ListOfTrnHdr"
          :key="orderHdr.id"
          style="width:100%;height:auto;margin-bottom:8px;background-color:#F4B95F;"
        >
          <v-layout wrap>
            <v-flex xs7>
              <p
                style="margin:8px;margin-bottom:0px;text-align:left;font-size:14px !important;"
              >{{ orderHdr.oa }}</p>
              <p
                style="margin:8px;margin-top:0px !important;margin-bottom:0px;text-align:left;font-size:14px !important;"
              >{{ orderHdr.schdTypeName }}</p>
              <p
                style="margin:8px;margin-top:0px !important;margin-bottom:0px;text-align:left;font-size:14px !important;"
              >{{ orderHdr.mx }}</p>
              <p
                style="margin:8px;margin-top:0px !important;text-align:left;font-size:14px !important;"
              >{{ orderHdr.dy }}</p>
            </v-flex>
            <v-flex xs5>
              <div style="margin:8px;">
                <p
                  v-if="orderHdr.lz !=''"
                  style="margin:0px;font-size:25px !important;text-align: right;"
                >{{ orderHdr.lz }}</p>
                <p
                  v-if="orderHdr.ez !=''"
                  style="margin:0px;font-size:14px !important;text-align: right;overflow-wrap: break-word;"
                >{{ orderHdr.ez }}</p>
                <p
                  v-if="orderHdr.y !=''"
                  style="margin:0px;font-size:14px !important;text-align: right;overflow-wrap: break-word;"
                >{{ orderHdr.y }}</p>
                <p
                  v-if="orderHdr.ly !=''"
                  style="margin:0px;font-size:14px !important;text-align: right;overflow-wrap: break-word;"
                >{{ orderHdr.ly }}</p>
                <p
                  v-if="orderHdr.en !='' && (orderHdr.mw == 3)"
                  style="margin:0px;font-size:12px !important;text-align: right;overflow-wrap: break-word;"
                >{{ orderHdr.en }}</p>
              </div>
            </v-flex>
          </v-layout>
          <!-- order Dtl -->
          <v-layout wrap xs12 style="padding:0px 5px 0px 5px;">
            <v-card style="width:100%;height:auto;background-color:whitesmoke;">
              <v-layout
                v-for="orderDtl in orderHdr.ListOfTrnDtl"
                :key="orderDtl.id"
                wrap
                style="border-bottom:0.5px solid gainsboro;"
              >
                <v-flex xs5>
                  <p
                    v-if="orderDtl.ln != ''"
                    class="orderDtlMediumTxt"
                  >{{ orderDtl.ll }} - {{ orderDtl.ln }}</p>
                  <p v-if="orderDtl.ln == ''" class="orderDtlMediumTxt">{{ orderDtl.ll }}</p>
                  <p class="orderDtlMediumTxt">{{ orderDtl.lm }}</p>
                  <!-- <p class="orderDtlMediumTxt">{{ orderDtl.ln }}</p> -->
                </v-flex>
                <v-flex v-if="orderDtl.lx>0" xs2>
                  <p
                    style="margin:0px;margin-top:10px;text-align: right;color:green;"
                  >{{$t('Completed')}}</p>
                </v-flex>
                <v-flex v-if="orderDtl.fi>0 && orderDtl.mj == null" xs2>
                  <p
                    style="margin:0px;margin-top:10px;text-align: right;color:red;"
                  >{{$t('Cancelled')}}</p>
                </v-flex>
                <v-flex v-if="orderDtl.fi>0 && orderDtl.mj != null" xs2>
                  <p
                    style="margin:0px;margin-top:10px;text-align: right;color:red;"
                  >{{$t('Refund')}}</p>
                </v-flex>
                <v-flex v-if="orderDtl.lx==0 && orderDtl.fi==0" xs2>
                  <p
                    style="margin:0px;margin-top:10px;text-align: right;color:orange;"
                  >{{$t('Progress')}}</p>
                </v-flex>
                <v-flex xs2>
                  <p style="margin:10px;text-align: right;">{{ orderDtl.lo }}</p>
                </v-flex>
                <v-flex xs2>
                  <p class="orderDtlSmallTxt">{{ orderDtl.rowAmt }}</p>
                </v-flex>
                <v-flex xs1>
                  <button
                    v-if="orderDtl.rx == 1"
                    style="background-color:#1976d2;height:30px;color:white;margin:5px 0px 0px 0px;padding:2px;font-size:10px;border-radius:5px;"
                    @click="undoOrder(orderDtl.lk,1)"
                  >{{$t('Undo')}}</button>
                  <button
                    v-if="orderDtl.rx == 3 && realKtnId== 0"
                    style="background-color:#1976d2;height:30px;color:white;margin:5px 0px 0px 0px;padding:2px;font-size:10px;border-radius:5px;"
                    @click="undoOrder(orderDtl.lk,3)"
                  >{{$t('Undo')}}</button>
                </v-flex>
              </v-layout>
            </v-card>
          </v-layout>
          <v-layout
            v-if="orderHdr.rs>0 && realKtnId== 0 && sltStallId==0"
            wrap
            xs12
            style="padding:5px;padding-top:0px;padding-bottom:0px;"
          >
            <v-card style="width:100%;height:auto;background-color:#dddddd;">
              <v-layout wrap style="border-bottom:0.5px solid gainsboro;">
                <!-- order bottom -->
                <v-flex xs7>
                  <p style="margin:10px;text-align: right;">{{$t('DeliveryCharges')}}</p>
                </v-flex>
                <v-flex xs2></v-flex>
                <v-flex xs2>
                  <p class="orderDtlSmallTxt">{{ orderHdr.rs.toFixed(2) }}</p>
                </v-flex>
                <v-flex xs1></v-flex>
              </v-layout>
            </v-card>
          </v-layout>
          <v-layout wrap xs12 style="padding:5px;padding-top:0px;padding-bottom:0px;">
            <v-card style="width:100%;height:auto;background-color:#dddddd;">
              <v-layout wrap style="border-bottom:0.5px solid gainsboro;">
                <!-- order bottom -->
                <v-flex xs7>
                  <p style="margin:10px;text-align: right;">{{$t('Total')}}</p>
                </v-flex>
                <v-flex xs2>
                  <p style="margin:10px;text-align: right;">{{ orderHdr.tolQtyPerOrder }}</p>
                </v-flex>
                <v-flex xs2>
                  <p
                    v-if="(realKtnId != 0) || (realKtnId == 0 && sltStallId!=0)"
                    class="orderDtlSmallTxt"
                  >{{ orderHdr.tolAmtPerOrder }}</p>
                  <p
                    v-if="realKtnId == 0 && sltStallId==0"
                    class="orderDtlSmallTxt"
                  >{{ orderHdr.oj.toFixed(2) }}</p>
                </v-flex>
                <v-flex xs1></v-flex>
              </v-layout>
            </v-card>
          </v-layout>
          <v-layout wrap xs12 style="padding:5px;padding-top:0px;">
            <v-card style="width:100%;height:auto;background-color:#c6c6c6;">
              <v-layout wrap style="border-bottom:0.5px solid gainsboro;">
                <!-- order bottom -->
                <v-flex xs7></v-flex>
                <v-flex xs2>
                  <p style="margin:0px;margin-top:10px;text-align:center;">{{$t('PaidAmt')}}</p>
                </v-flex>
                <v-flex xs2>
                  <p
                    v-if="orderHdr.ListOfTrnDtl[0].mj != null && (realKtnId == 0 && sltStallId==0)"
                    class="orderDtlSmallTxt"
                  >{{ orderHdr.lh.toFixed(2)}}</p>
                  <p
                    v-if="orderHdr.ListOfTrnDtl[0].mj != null && (realKtnId != 0 || (realKtnId == 0 && sltStallId!=0))"
                    class="orderDtlSmallTxt"
                  >{{ orderHdr.tolAmtPerOrder}}</p>
                  <p v-if="orderHdr.ListOfTrnDtl[0].mj == null" class="orderDtlSmallTxt">0.00</p>
                </v-flex>
                <v-flex xs1></v-flex>
              </v-layout>
            </v-card>
          </v-layout>
        </v-card>
      </v-layout>
    </div>

    <v-layout class="text-xs-center">
      <v-dialog v-model="undoOrderDialog" persistent width="400">
        <v-card>
          <v-card-title
            class="headline primary lighten-2"
            primary-title
            style="color: white;"
          >{{$t('Inform')}}</v-card-title>
          <v-card-text>
            <h3>{{$t('sureToUndoThisOrderItemTxt')}}</h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="default" flat @click="sureToUndo()">{{$t('Yes')}}</v-btn>
            <v-btn color="primary" flat @click="undoOrderDialog = false">{{$t('No')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout class="text-xs-center">
      <v-dialog v-model="loadingDialog" persistent width="1000">
        <v-card height="200">
          <v-card-text>
            <br />
            <!-- <v-btn color="primary" style="float:right;" @click="closeLoadingDialog()">X</v-btn> -->
            <v-layout row wrap align-center>
              <v-progress-circular
                :size="100"
                :width="8"
                color="primary"
                indeterminate
                class="progress-circular"
              ></v-progress-circular>
            </v-layout>
            <div>
              <h3 class="loadingMsg">In progress, please wait a moment.</h3>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>

    <VersionDialog v-if="versionError"></VersionDialog>
  </v-app>
</template>

<script>
import JS from './JsonService'
import VersionDialog from '../src/VersionNotMatchDialog'
import globalVar from './GlobalVar.js'
// import { Howl, Howler } from 'howler'
export default {
  components: {
    VersionDialog
  },
  filters: {
    currency(amount) {
      const amt = Number(amount)
      return amt.toFixed(2)
    }
  },
  data() {
    return {
      globalVar: globalVar,
      errorList: '',
      ListOfTrnHdr: [],
      ListOfTrnDtl: [],
      loadingDialog: false,
      versionError: false,
      sltStall: 'All',
      sltStallId: 0,
      stallList: [],
      stallNameList: [],
      dpSE: false,
      dpdateSE: '',
      dpdateStart: '',
      dpdateEnd: '',
      invalidStartEnd: false,
      invalidStartexceedEnd: false,
      summary: [],
      realKtnId: 0,
      undoOrderDtail: '',
      undoOrderDialog: false,
      undoType: 0
    }
  },
  created: function() {
    let userInfo = JSON.parse(sessionStorage.getItem('backendLoginInfo'))
    this.realKtnId = userInfo.KtnID

    // sessionStorage.setItem('backEndAddOrd', false)
    this.dpdateFrom = new Date().toISOString().substr(0, 10)
    this.dpdateTo = new Date().toISOString().substr(0, 10)
    this.dpdateStart = new Date(new Date()).toISOString().substr(0, 10)
    this.dpdateEnd = new Date(new Date()).toISOString().substr(0, 10)
    const [year, month, day] = this.dpdateStart.split('-')
    const [year2, month2, day2] = this.dpdateEnd.split('-')
    this.dpdateSE =
      `${day}/${month}/${year}` + ' ~ ' + `${day2}/${month2}/${year2}`

    this.checkStall()
    this.getOrderList()
  },
  destroyed() {
    console.log('destroy')
  },
  methods: {
    checkStall() {
      if (globalVar.mode == 'normal') {
        let userInfo = JSON.parse(sessionStorage.getItem('backendLoginInfo'))
        if (userInfo.KtnID == 0) {
          this.getStallList()
        } else {
          this.stallList = []
        }
      } else if (globalVar.mode == 'lite') {
        this.stallList = []
      }
    },
    getStallList() {
      let mchCode = sessionStorage.getItem('backendMchCode')
      //console.log(mchCode)

      this.versionError = false
      var version = sessionStorage.getItem('version')
      const url = 'Back/GetKtnList'
      const parameter = {
        av: version,
        kp: mchCode
      }

      JS.request(url, parameter)
        .then(response => {
          console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            if (response.data.ListOfKtn) {
              this.errorList = ''
              this.stallList = response.data.ListOfKtn
              this.stallNameList = ['All']
              for (let i = 0; i < response.data.ListOfKtn.length; i++) {
                this.stallNameList.push(
                  response.data.ListOfKtn[i].qz +
                    ' - ' +
                    response.data.ListOfKtn[i].ra
                )
              }
              console.log(this.stallNameList)
            } else {
              this.errorList = response.data
            }
          }
        })
        .catch(error => {
          //console.log(error)
          this.errorList = error
          this.versionError = false
        })
    },
    onSelectStall(event) {
      this.sltStall = event
      console.log(this.sltStall)
      console.log(event)

      //get Ktn Id
      for (let i = 0; i < this.stallList.length; i++) {
        if (
          this.sltStall ==
          this.stallList[i].qz + ' - ' + this.stallList[i].ra
        ) {
          this.sltStallId = this.stallList[i].rd
          break
        } else {
          this.sltStallId = 0
        }
      }
    },
    onChangeDateSE(start, end) {
      this.dpSE = false
      // console.log(start)
      // console.log(end)
      if (start == '' || start == undefined || end == '' || end == undefined) {
        this.invalidStartEnd = true
      } else {
        this.invalidStartEnd = false
        if (start > end) {
          window.scrollTo(0, 0)
          this.invalidStartexceedEnd = true
        } else {
          this.invalidStartexceedEnd = false
          this.dpdateStart = start
          this.dpdateEnd = end
          const [year, month, day] = this.dpdateStart.split('-')
          const [year2, month2, day2] = this.dpdateEnd.split('-')

          this.dpdateSE =
            `${day}/${month}/${year}` + ' ~ ' + `${day2}/${month2}/${year2}`

          // console.log(this.dpdateStart)
          // console.log(this.dpdateEnd)
          // console.log(new Date(this.dpdateStart).getTime())
          // console.log(new Date(this.dpdateEnd).getTime())
        }
      }
    },
    searchSummary() {
      if (this.dpdateStart == '' && this.dpdateEnd == '') {
        this.invalidStartEnd = true
      } else {
        this.invalidStartEnd = false
        this.loadingDialog = true
        this.versionError = false
        let mchCode = sessionStorage.getItem('backendMchCode')
        //console.log(mchCode)
        let userInfo = JSON.parse(sessionStorage.getItem('backendLoginInfo'))
        if (userInfo.KtnID != 0) {
          this.sltStallId = userInfo.KtnID
        }
        //console.log(userInfo)
        //console.log(userInfo.KtnID)
        let dateFrom = new Date(this.dpdateStart).getTime()
        let dateTo = new Date(this.dpdateEnd).getTime()
        var version = sessionStorage.getItem('version')
        const url = 'Back/GetOrderList'
        const parameter = {
          av: version,
          kp: mchCode,
          rd: this.sltStallId,
          gm: 1,
          cr: dateFrom,
          cs: dateTo
        }
        console.log(parameter)
        JS.request(url, parameter)
          .then(response => {
            //console.log(response.data)
            if (
              response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
              response.data == 'Version Not Match'
            ) {
              this.loadingDialog = false
              this.versionError = true
            } else {
              this.versionError = false
              if (response.data.ListOfTrnHdr) {
                this.errorList = ''

                console.log(this.ListOfTrnHdr)
                console.log(response.data)
                console.log(response.data.ListOfTrnHdr)

                this.ListOfTrnHdr = response.data.ListOfTrnHdr
                this.summary = response.data.Summary
                for (let i = 0; i < this.ListOfTrnHdr.length; i++) {
                  this.ListOfTrnHdr[i].mx =
                    new Date(this.ListOfTrnHdr[i].mx)
                      .toString()
                      .substring(8, 10) +
                    ' ' +
                    new Date(this.ListOfTrnHdr[i].mx)
                      .toString()
                      .substring(4, 7) +
                    ' ' +
                    new Date(this.ListOfTrnHdr[i].mx)
                      .toString()
                      .substring(11, 15) +
                    ' ' +
                    new Date(this.ListOfTrnHdr[i].mx).toLocaleTimeString()
                  this.ListOfTrnHdr[i].ListOfTrnDtl = []

                  let btnName = JSON.parse(
                    sessionStorage.getItem('SchdTypeBtnName')
                  )
                  if (this.ListOfTrnHdr[i].mw == 1) {
                    if (btnName.DineIn == '') {
                      this.ListOfTrnHdr[i].schdTypeName = 'Dine In, Pre-order'
                    } else {
                      this.ListOfTrnHdr[i].schdTypeName = btnName.DineIn
                    }
                  } else if (this.ListOfTrnHdr[i].mw == 2) {
                    if (btnName.TakeAway == '') {
                      this.ListOfTrnHdr[i].schdTypeName = 'Take Away'
                    } else {
                      this.ListOfTrnHdr[i].schdTypeName = btnName.TakeAway
                    }
                  } else if (this.ListOfTrnHdr[i].mw == 3) {
                    if (btnName.Delivery == '') {
                      this.ListOfTrnHdr[i].schdTypeName = 'Delivery'
                    } else {
                      this.ListOfTrnHdr[i].schdTypeName = btnName.Delivery
                    }
                  } else if (this.ListOfTrnHdr[i].mw == 4) {
                    if (btnName.ScanOrder == '') {
                      this.ListOfTrnHdr[i].schdTypeName = 'Dine In, Scan, Order'
                    } else {
                      this.ListOfTrnHdr[i].schdTypeName = btnName.ScanOrder
                    }
                  }
                }
                this.getListListOfTrnDtlPerItem(response.data.ListOfTrnDtl)
              } else {
                this.loadingDialog = false
                this.errorList = response.data
              }
            }
          })
          .catch(error => {
            //console.log(error)
            this.versionError = false
            this.loadingDialog = false
            this.errorList = error
          })
      }
    },
    getOrderList() {
      this.loadingDialog = true
      this.versionError = false
      let mchCode = sessionStorage.getItem('backendMchCode')
      //console.log(mchCode)
      let userInfo = JSON.parse(sessionStorage.getItem('backendLoginInfo'))
      //console.log(userInfo)
      //console.log(userInfo.KtnID)
      let dateFrom = new Date(this.dpdateStart).getTime()
      let dateTo = new Date(this.dpdateEnd).getTime()
      var version = sessionStorage.getItem('version')
      const url = 'Back/GetOrderList'
      const parameter = {
        av: version,
        kp: mchCode,
        rd: userInfo.KtnID,
        gm: 1,
        cr: dateFrom,
        cs: dateTo
      }
      console.log(parameter)
      JS.request(url, parameter)
        .then(response => {
          //console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.loadingDialog = false
            this.versionError = true
          } else {
            this.versionError = false
            if (response.data.ListOfTrnHdr) {
              this.errorList = ''

              console.log(this.ListOfTrnHdr)
              console.log(response.data)
              console.log(response.data.ListOfTrnHdr)

              this.ListOfTrnHdr = response.data.ListOfTrnHdr
              this.summary = response.data.Summary
              for (let i = 0; i < this.ListOfTrnHdr.length; i++) {
                this.ListOfTrnHdr[i].mx =
                  new Date(this.ListOfTrnHdr[i].mx)
                    .toString()
                    .substring(8, 10) +
                  ' ' +
                  new Date(this.ListOfTrnHdr[i].mx).toString().substring(4, 7) +
                  ' ' +
                  new Date(this.ListOfTrnHdr[i].mx)
                    .toString()
                    .substring(11, 15) +
                  ' ' +
                  new Date(this.ListOfTrnHdr[i].mx).toLocaleTimeString()
                this.ListOfTrnHdr[i].ListOfTrnDtl = []

                let btnName = JSON.parse(
                  sessionStorage.getItem('SchdTypeBtnName')
                )
                if (this.ListOfTrnHdr[i].mw == 1) {
                  if (btnName.DineIn == '') {
                    this.ListOfTrnHdr[i].schdTypeName = 'Dine In, Pre-order'
                  } else {
                    this.ListOfTrnHdr[i].schdTypeName = btnName.DineIn
                  }
                } else if (this.ListOfTrnHdr[i].mw == 2) {
                  if (btnName.TakeAway == '') {
                    this.ListOfTrnHdr[i].schdTypeName = 'Take Away'
                  } else {
                    this.ListOfTrnHdr[i].schdTypeName = btnName.TakeAway
                  }
                } else if (this.ListOfTrnHdr[i].mw == 3) {
                  if (btnName.Delivery == '') {
                    this.ListOfTrnHdr[i].schdTypeName = 'Delivery'
                  } else {
                    this.ListOfTrnHdr[i].schdTypeName = btnName.Delivery
                  }
                } else if (this.ListOfTrnHdr[i].mw == 4) {
                  if (btnName.ScanOrder == '') {
                    this.ListOfTrnHdr[i].schdTypeName = 'Dine In, Scan, Order'
                  } else {
                    this.ListOfTrnHdr[i].schdTypeName = btnName.ScanOrder
                  }
                }
              }
              this.getListListOfTrnDtlPerItem(response.data.ListOfTrnDtl)
            } else {
              this.loadingDialog = false
              this.errorList = response.data
            }
          }
        })
        .catch(error => {
          //console.log(error)
          this.versionError = false
          this.loadingDialog = false
          this.errorList = error
        })
    },
    getListListOfTrnDtlPerItem(data) {
      for (let i = 0; i < this.ListOfTrnHdr.length; i++) {
        for (let j = 0; j < data.length; j++) {
          if (this.ListOfTrnHdr[i].lf == data[j].lf) {
            this.ListOfTrnHdr[i].tolAmtPerOrder = 0
            this.ListOfTrnHdr[i].tolQtyPerOrder = 0
            this.ListOfTrnHdr[i].ListOfTrnDtl.push(data[j])
            //console.log(this.ListOfTrnHdr[i].ListOfTrnDtl)

            for (let k = 0; k < this.ListOfTrnHdr[i].ListOfTrnDtl.length; k++) {
              this.ListOfTrnHdr[i].ListOfTrnDtl[k].rowAmt =
                this.ListOfTrnHdr[i].ListOfTrnDtl[k].lt +
                this.ListOfTrnHdr[i].ListOfTrnDtl[k].og +
                this.ListOfTrnHdr[i].ListOfTrnDtl[k].oh

              this.ListOfTrnHdr[i].ListOfTrnDtl[k].rowAmt = Number(
                this.ListOfTrnHdr[i].ListOfTrnDtl[k].rowAmt
              ).toFixed(2)

              var totalPerOder
              if (this.ListOfTrnHdr[i].ListOfTrnDtl[k].fi == 0) {
                totalPerOder =
                  Number(this.ListOfTrnHdr[i].tolAmtPerOrder) +
                  Number(this.ListOfTrnHdr[i].ListOfTrnDtl[k].rowAmt)
              } else {
                totalPerOder = Number(this.ListOfTrnHdr[i].tolAmtPerOrder)
              }

              this.ListOfTrnHdr[i].tolAmtPerOrder = Number(
                totalPerOder
              ).toFixed(2)

              this.ListOfTrnHdr[i].tolQtyPerOrder =
                this.ListOfTrnHdr[i].tolQtyPerOrder +
                this.ListOfTrnHdr[i].ListOfTrnDtl[k].lo

              // this.ListOfTrnHdr[i].tolAmtPerOrder.toFixed(2)
              //console.log(this.ListOfTrnHdr[i].tolAmtPerOrder)
            }
          }
        }
        //console.log(this.ListOfTrnHdr)
      }
      this.loadingDialog = false
    },
    undoOrder(val, type) {
      console.log(val)
      this.undoOrderDtail = val
      this.undoType = type
      this.undoOrderDialog = true
    },
    sureToUndo() {
      this.undoOrderDialog = false
      this.loadingDialog = true
      this.versionError = false

      let mchCode = sessionStorage.getItem('backendMchCode')
      //console.log(mchCode)
      let userName = sessionStorage.getItem('backendLoginedUserName')
      let userInfo = JSON.parse(sessionStorage.getItem('backendLoginInfo'))
      console.log(userInfo)
      console.log(userInfo.KtnID)
      var version = sessionStorage.getItem('version')
      const url = 'Back/SetTrnDtlDate'
      const parameter = {
        av: version,
        kp: mchCode,
        x: userName, //user name
        rd: userInfo.KtnID,
        gm: this.undoType, //Note : 1 = Delete, 3 = End
        ma: this.undoOrderDtail,
        rw: false
      }
      console.log(parameter)
      JS.request(url, parameter)
        .then(response => {
          console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            if (response.data.ht) {
              this.loadingDialog = false
              this.getOrderList()
            } else {
              this.loadingDialog = false
              this.errorList = response.data
            }
          }
        })
        .catch(error => {
          //console.log(error)
          this.loadingDialog = false
          this.versionError = false
          this.errorList = error
        })
    }
  }
}
</script>

<style>
.dateTxt {
  font-size: 16px;
}
.orderDtlSmallTxt {
  margin: 10px;
  text-align: right;
  font-size: 14px !important;
}
.orderDtlMediumTxt {
  padding-left: 5px;
  text-align: left;
  font-size: 14px !important;
  margin: 0;
}
.orderTlAmtTxt {
  margin: 10px;
  text-align: right;
  font-size: 20px !important;
}
.dltRowBtn {
  float: right;
  padding: 10px;
  padding-top: 10px;
}
@media (max-width: 500px) {
  .dltRowBtn {
    float: right;
    padding: 0px;
    padding-top: 10px;
    color: coral;
  }
}
</style>
